import React, { Fragment, useState, useEffect } from "react";
import { Lock } from "@mui/icons-material";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import "./PaymentModal.css";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import CreditCardInput from "react-credit-card-input";
import { logout,  } from '../../actions/authActions'
import {
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  DialogActions,
  Button,
} from "@mui/material";
import {  loadUser } from '../../actions/authActions'

import creditCardType from "credit-card-type";
import {
  makePayment,
  getCardType,
  buySubscription,
  runningSubscription,
  dashboardSubscription,
} from "../../actions/subscription.js";
import { BeatLoader } from "react-spinners";


  let isSubscribing =localStorage.getItem("isSubscribing")

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 5,
          top: 16,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        {/* <CloseIcon /> */}
        <img
          src="assets/icons/close_icon.svg"
          alt="close button icon"
          height={13}
          width={13}
        />
      </IconButton>
    ) : null}
  </DialogTitle>
);

const PaymentModal = (props) => {
  const { frontLabelsName } = props.label;
    const dispatch = useDispatch();
  const userName = localStorage.getItem("user");
  const { showModal, closeModal, amount, getCardType, makePayment, id,loadUser,logout } = props;
  const history = useHistory();
  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");

  const [cardNumber, setCardNumber] = useState("");

  const [bookingLoading, setBookingLoading] = useState(false);
  const [error, setError] = useState("");
  const [errorExpiry, setErrorExpiry] = useState("");
  const [errorCvv, setErrorCvv] = useState("");
  const [errorNumber, setErrorNumber] = useState("");
  const [name, setName] = useState("");
  const [errorName, setErrorName] = useState("");

  useEffect(() => {
    if (errorExpiry || errorCvv || errorNumber) {
      setError("");
    }
    if (cardNumber) {
      setErrorNumber("");
      setError("");
    }
    if (cvc) {
      setErrorCvv("");
      //setError("");
    }
    if (expiry) {
      setErrorExpiry("");
      //setError("");
    }
  }, [cardNumber, cvc, errorCvv, errorExpiry, errorNumber, expiry]);

  const oncloseModal = () => {
    closeModal(false);

    setBookingLoading(false);
    setCardNumber("");
    setExpiry("");
    setCvc("");
    setError("");
    setErrorExpiry("");
    setErrorCvv("");
    setErrorNumber("");
    setErrorName("");
    setName("");
  };

  const handleCardNumberChange = (e) => {
    setCardNumber(e.target.value);
  };

  const handleCardExpiryChange = (e) => {
  
    setExpiry(e.target.value);
  };

  const handleCardCVCChange = (e) => {

    const input = e.target.value;

    // Allow only digits and limit to 3 characters
    if (/^\d{0,3}$/.test(input)) {
      setCvc(input);
    }

  };

  function isValidName(name) {
    const regex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
    return regex.test(name.trim());
  }

  const handlePay = () => {
    if (name == "") {
      setErrorName(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_cardholder_name_is_required")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_cardholder_name_is_required"
              )[0]["value"] || "lbl_cardholder_name_is_required"
            : "lbl_cardholder_name_is_required"
          : "lbl_cardholder_name_is_required"
      );
    }else if(!isValidName(name)){
      setErrorName(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_only_alphabets_are_allowed")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_only_alphabets_are_allowed"
              )[0]["value"] || "lbl_only_alphabets_are_allowed"
            : "lbl_only_alphabets_are_allowed"
          : "lbl_only_alphabets_are_allowed"
      );
    }
     else {
      setErrorName("");
      function getDate(date) {
        const d = new Date();
        let month = d.getMonth();
        let a = expiry.split("/");

        let year = d.getFullYear().toString().substr(-2);
        if (a[1].trim() >= year) {
          if (a[1].trim() == year && a[0].trim() < month + 1) {
            return false;
          } else return true;
        } else return false;
      }
      function cardType(cardNumber) {
        // returns card type; should not rely on this for checking if a card is valid
        cardNumber = cardNumber.split(" ").join("");
        var o = {
          electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
          maestro:
            /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
          dankort: /^(5019)\d+$/,
          interpayment: /^(636)\d+$/,
          unionpay: /^(62|88)\d+$/,
          korta: /^(6|4|5)\d+$/,
          visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
          mastercard: /^5[1-5][0-9]{14}$/,
          amex: /^3[47][0-9]{13}$/,
          diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
          discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
          jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
        };
        for (var k in o) {
          if (o[k].test(cardNumber)) {
            return k;
          }
        }
        return null;
      }
    if (!cardNumber || !expiry || !cvc) {
      if (!errorExpiry && !errorCvv && !errorNumber) {
        setError(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_card_details_is_required")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_card_details_is_required"
                )[0]["value"] || "lbl_card_details_is_required"
              : "lbl_card_details_is_required"
            : "lbl_card_details_is_required"
        );
      }
    }
  
    if (cardNumber && expiry && cvc) {
      if (cardType(cardNumber) && getDate(expiry)) {
      setError("");
      setErrorExpiry("");
      setErrorCvv("");
      setErrorNumber("");
      setBookingLoading(true);
      const userName1 = localStorage.getItem("user");
      var card_type = "";
      var visaCards = creditCardType(cardNumber);

      let a = visaCards[0].type;
      const output = a.charAt(0).toUpperCase() + a.slice(1);

      getCardType().then((res) => {
        let filteredData = res.filter(function (obj) {
          return obj.name === output;
        });

        card_type = filteredData[0].type;

        let obj = {
          category: "card",
          amount: amount,
          currency: "ISK",
          description: "payment by card",
          payment_type: card_type,
          card_number: cardNumber.split(" ").join(""),
          expiration_month: expiry.substring(0, 2),
          expiration_year: expiry.slice(-2),
          cvv: cvc,
          card_holder_name: name,
        };
        makePayment(obj)
          .then((res) => {
            const data = {
              plan_id: id,
              user_id: userName,
              transactionId:res.data.result._id,
              isRegistrationCompleted:true,
              selectedLang:localStorage.getItem("i18nextFront")
            };
          
            closeModal(false);
            setCardNumber("");
            setExpiry("");
            setCvc("");
            setErrorName("");
            setName("");
            setBookingLoading(false);
            if (res.status == 200) {
            toast.success(frontLabelsName
              ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
                ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                "value"
                ] || res.data.message
                : res.data.message
              : res.data.message);
            }else{
            
              toast.error(frontLabelsName
                ? frontLabelsName.filter((e) => e.key == res?.data?.result?.error_code).length > 0
                  ? frontLabelsName.filter((e) => e.key == res?.data?.result?.error_code)[0][
                  "value"
                  ] ||res?.data?.result?.error_code
                  : res?.data?.result?.error_code
                : res?.data?.result?.error_code);
            }
         
            if (res.status == 200) {
              props.buySubscription(data).then((res1) => {
           
                if (res1.status == 200) {
                toast.success(frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == res1.data.message).length > 0
                    ? frontLabelsName.filter((e) => e.key == res1.data.message)[0][
                    "value"
                    ] || res1.data.message
                    : res1.data.message
                  : res1.data.message);
                props.runningSubscription(userName1).then((res) => {
                  props.setRunningSub(res);
                })            
                props.dashboardSubscription().then((res) => {
                  props.setDashboardSubDetails(res);
                });
                loadUser()
                localStorage.removeItem("isSubscribing")
                dispatch({
                  type:"SET_STEP",
                  payload:{step:0,status:false}
               });
            
               localStorage.setItem("currentStepIndex", 0)
                history.push("/dashboard", { replace: true });
              }
              })
              .catch((err) => {
                setBookingLoading(false);
                toast.error(err.response.data.message);
              });
            }
          })
          .catch((err) => {
           if(err.response.status==401){
            history.push( "/login")
            dispatch({
              type:"SET_STEP",
              payload:{step:0,status:false}
           });
           localStorage.removeItem("isSubscribing")
         
           logout()
           }
            setBookingLoading(false);
            toast.error(err.response.data.message);
          });
      });
    } else {
      setBookingLoading(false);
      setError(
        frontLabelsName
          ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_enter_valid_detail"
            ).length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_enter_valid_detail"
              )[0]["value"] || "lbl_please_enter_valid_detail"
            : "lbl_please_enter_valid_detail"
          : "lbl_please_enter_valid_detail"
      );
    }
    }
  }
  };

  function priceFormat(x) {
    const data = x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  return (
    <Fragment>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showModal}
        // onClose={oncloseModal}
        disableBackdropClick
  disableEscapeKeyDown

  onClose={(event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      oncloseModal();
    }
  }}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "20px",
            paddingTop: "6px",
          },
        }}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => oncloseModal()}
          sx={{
            borderBottom: "1px solid #956800",
            paddingTop: "8px",
            paddingBottom: "8px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="body1"
            component="h6"
            sx={{
              fontSize: "1.25rem",
              fontWeight: "600",
              color: "#956800",
              lineHeight:1.1
            }}
          >
            {frontLabelsName
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_almost_there_to_purchase_subscription"
                ).length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_almost_there_to_purchase_subscription"
                  )[0]["value"] || "lbl_almost_there_to_purchase_subscription"
                : "lbl_almost_there_to_purchase_subscription"
              : "lbl_almost_there_to_purchase_subscription"}
          </Typography>
        </BootstrapDialogTitle>

        <DialogContent dividers={true}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{ color: "#929292", fontWeight: "600", fontSize: "1rem" }}
              >
                {frontLabelsName
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_pay_to_purchase_subscription"
                    ).length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_pay_to_purchase_subscription"
                      )[0]["value"] || "lbl_pay_to_purchase_subscription"
                    : "lbl_pay_to_purchase_subscription"
                  : "lbl_pay_to_purchase_subscription"}
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: "2rem",
                  fontWeight: 600,
                  fontStyle: "normal",
                  mt: "0.10rem",
                }}
              >
                Kr{priceFormat(amount)}{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <img
                src="assets/icons/visa-card.svg"
                alt="stripe-visa-card-logo"
                style={{
                  width: "64px",
                  height: "40px",
                  margin: "1rem 0.25rem 0.5rem 0",
                }}
              />
              <img
                src="assets/icons/master-card.svg"
                alt="stripe-master-card-logo"
                style={{
                  width: "64px",
                  height: "40px",
                  margin: "1rem 0.25rem 0.5rem 0",
                }}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItem: "center",
            }}
          >
            <Grid container>
              <Grid item xs={12} md={12} lg={12}>
                <Typography variant="h5" sx={{ mt: "0.875rem" }}>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_card_information")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_card_information"
                        )[0]["value"] || "lbl_card_information"
                      : "lbl_card_information"
                    : "lbl_card_information"}
                </Typography>
              </Grid>
           <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  type="text"
                  name="name"
                  placeholder={
                    frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_cardholder_name")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_cardholder_name"
                          )[0]["value"] || "lbl_cardholder_name"
                        : "lbl_cardholder_name"
                      : "lbl_cardholder_name"
                  }
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    }
                  }}
                  sx={{
                    mb: 1,
                    mt: 1,
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "0.875rem",
                        fontFamily: "Roboto, sans-serif",
                        opacity:0.9
                      },
                    ".MuiInputBase-input": {
                      background: "#ffffff",
                      borderRadius: "10px",
                    },

                    ".MuiTextField-root": {
                      background: "#ffffff",
                      borderRadius: "10px",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#000",

                        // background: '#FFF'
                      },
                      "&:hover fieldset": {
                        borderColor: "#000",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #000",
                        borderColor: "#000",
                      },
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                />
                {errorName && (
                  <div className=" mb-2">
                    <span style={{ color: "#ff3860", fontSize: "13px" }}>
                      {errorName}
                    </span>
                  </div>
                )}
              </Grid>
              <Grid item xs={12} className="credit-card-grid" sx={{ pt: 0.5 }}>
                <CreditCardInput
                  cardNumberInputProps={{
                    value: cardNumber,
                    onChange: handleCardNumberChange,
                    // onBlur: handleCardNumberBlur,
                    onError: (err) => setErrorNumber(err),
                    // onFocus: handleCardNumberFocus,
                  }}
                  cardExpiryInputProps={{
                    value: expiry,
                    onChange: handleCardExpiryChange,
                    // onFocus: handleCardFocus,

                    // readOnly: isDisabled,
                    onError: (err) => setErrorExpiry(err),
                  }}
                  cardCVCInputProps={{
                    value: cvc,
                    onChange: handleCardCVCChange,
                    // readOnly: errorDisabled,
                    // onFocus: handleCvvFocus,

                    onError: (err) => setErrorCvv(err),
                  }}
                  fieldClassName="input-payment"
                  fieldStyle={{ width: "100%" }}
                  inputStyle={{
                    height: "50px",
                    border: "1px solid #000 ",
                    borderRadius: " 9px ",
                    paddingLeft: "10px",
                  }}
                />
              </Grid>
              {error && (
                <div className="mt-1">
                  <span style={{ color: "#ff3860", fontSize: "13px" }}>
                    {error}
                  </span>
                </div>
              )}
            </Grid>
          </Grid>
          {/* </Grid> */}
        </DialogContent>

        <DialogActions>
          <Grid container spacing={1} justifyContent="center" sx={{ mt: 1 }}>
            <Button
              size="smaill"
              type="submit"
              onClick={handlePay}
              variant="contained"
              disabled={bookingLoading ? true : false}
              startIcon={bookingLoading ? null : <Lock />}
              sx={{
                background: "#2ECC71",
                borderRadius: "25px",
                fontSize: "0.875rem",
                fontWeight: "medium",
                letterSpacing: "0.12px",
                width: "170px",
                height: "46px",
                color: "#ffffff",
                "&:hover": {
                  background: "#00C579",
                },
              }}
            >
              {bookingLoading ? (
                <BeatLoader color="#005da1" size="10" />
              ) : frontLabelsName ? (
                frontLabelsName.filter((e) => e.key == "lbl_pay").length > 0 ? (
                  frontLabelsName.filter((e) => e.key == "lbl_pay")[0]["value"] ||
                  "lbl_pay"
                ) : (
                  "lbl_pay"
                )
              ) : (
                "lbl_pay"
              )}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  makePayment,
  getCardType,
  buySubscription,
  runningSubscription,
  dashboardSubscription,
  loadUser,logout
})(PaymentModal);
